import type { FontSource } from 'expo-font';

export const fontFiles: {
  [key: string]: FontSource;
} = {
  'Poppins-Regular': require('../assets/fonts/Poppins-Regular.ttf'),
  'Poppins-Italic': require('../assets/fonts/Poppins-Italic.ttf'),
  'Poppins-Light': require('../assets/fonts/Poppins-Light.ttf'),
  'Poppins-LightItalic': require('../assets/fonts/Poppins-LightItalic.ttf'),
  'Poppins-Bold': require('../assets/fonts/Poppins-Bold.ttf'),
  'Poppins-BoldItalic': require('../assets/fonts/Poppins-BoldItalic.ttf'),
  'Poppins-Medium': require('../assets/fonts/Poppins-Medium.ttf'),
  'Poppins-MediumItalic': require('../assets/fonts/Poppins-MediumItalic.ttf'),
  'Poppins-SemiBold': require('../assets/fonts/Poppins-SemiBold.ttf'),
  'Poppins-SemiBoldItalic': require('../assets/fonts/Poppins-SemiBoldItalic.ttf'),
  'Poppins-Thin': require('../assets/fonts/Poppins-Thin.ttf'),
  'Poppins-ThinItalic': require('../assets/fonts/Poppins-ThinItalic.ttf'),

  'Inter-Regular': require('../assets/fonts/Inter-Regular.ttf'),
  'Inter-Light': require('../assets/fonts/Inter-Light.ttf'),
  'Inter-Bold': require('../assets/fonts/Inter-Bold.ttf'),
  'Inter-Medium': require('../assets/fonts/Inter-Medium.ttf'),
  'Inter-SemiBold': require('../assets/fonts/Inter-SemiBold.ttf'),
  'Inter-Thin': require('../assets/fonts/Inter-Thin.ttf'),
  'Inter-SemiBoldItalic': require('../assets/fonts/Inter-SemiBoldItalic.ttf'),
  'Inter-Italic': require('../assets/fonts/Inter-Italic.ttf'),
};
